const __version__ ='avesis_v1.0.0'

module.exports = {
    __version__
}

